import type { FC } from 'react';
import classNames from 'classnames';

import style from './style.scss';

interface Props {
  size?: number;
  className?: string;
}

const SeparatorDot: FC<Props> = ({ size = 3, className }) => (
  <span
    className={classNames(style.separatorDot, className)}
    style={{ width: size, height: size }}
  />
);

SeparatorDot.displayName = 'SeparatorDot';

export default SeparatorDot;
